// import { format } from "date-fns";

import { faTrash } from "@fortawesome/fontawesome-free-solid";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useState } from "react";
import Modal from "../../components/b2b/Modal";

export const COLUMNS = [
  {
    Header: "Event Name",

    sticky: "left",
  },
  {
    Header: "Start Date",

    sticky: "left",
  },

  {
    Header: "End Date",

    sticky: "left",
  },
  {
    Header: "Region/City",

    sticky: "left",
  },
  {
    Header: "Markup",
  },
  {
    Header: "Actions",
  },
];
